import '../../KpiCardCommon.scss';
import '../../CommonStyles.scss';
import { DataSource } from 'types/admin/analytics';
import { CardHeader } from '../CardHeader/CardHeader';

export const KpiBase = ({ label, value, sources }: { label: string; value: number; sources: DataSource[] }) => {
  return (
    <>
      <CardHeader title={label} badges={sources} />
      <div className='kpi-value'>{value.toLocaleString()}</div>
    </>
  );
};
